import { z } from 'zod';

export const US_STATE_CODES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
] as const;

export const Address = z.object({
  street: z.string().trim().min(1),
  city: z.string().trim().min(1),
  state: z.enum(US_STATE_CODES),
  zip: z.string().regex(/^\d{5}(-?\d{4})?$/, 'ZIP must be 5 or 9 digits'),
});
export type Address = z.infer<typeof Address>;

/** D365 company IDs (dataAreaId): 1–4 chars, uppercase. */
export const CompanyId = z
  .string()
  .trim()
  .min(1)
  .max(4)
  .transform((v) => v.toUpperCase());

export const Upn = z
  .string()
  .trim()
  .email()
  .transform((v) => v.toLowerCase());
